export function getDownloadUrl(promptFile: any) {
  const blob = new Blob([promptFile], { type: 'audio/wav' })

  const URL = window.URL || window.webkitURL

  const downloadUrl = URL.createObjectURL(blob)

  return downloadUrl
}
